import { render } from "./NewFormElement.vue?vue&type=template&id=b0505898&scoped=true&ts=true"
import script from "./NewFormElement.vue?vue&type=script&lang=ts"
export * from "./NewFormElement.vue?vue&type=script&lang=ts"

import "./NewFormElement.vue?vue&type=style&index=0&id=b0505898&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0505898"]])

export default __exports__